import { z } from "zod";

const assignableUserNodeSchema = z.object({
    name: z.string(),
    picture: z.string().nullable(),
    accountStatus: z.string()
});

const assignableUserEdgesSchema = z.object({
    node: assignableUserNodeSchema
});

const assignableUsersSchema = z.object({
    totalCount: z.number(),
    edges: z.array(assignableUserEdgesSchema)
});

const projectNodeSchema = z.object({
    key: z.string(),
    name: z.string(),
    projectUrl: z.string().nullable(),
    webUrl: z.string(),
    assignableUsers: assignableUsersSchema
});

const projectEdgesSchema = z.object({
    node: projectNodeSchema
});

const pageInfoSchema = z.object({
    hasNextPage: z.boolean()
});

const allJiraProjectsSchema = z.object({
    pageInfo: pageInfoSchema,
    edges: z.array(projectEdgesSchema)
});

const jiraSchema = z.object({
    allJiraProjects: allJiraProjectsSchema
});

export const jiraResponseSchema = z.object({
    jira: jiraSchema
});

export type AllJiraSitesResponseType = z.infer<typeof jiraResponseSchema>;
